import React from "react";
import { ChevronLeftIcon } from "@heroicons/react/outline";
import BuatPanduan from "./BuatPanduan";
import BuatKuis from "./BuatKuis";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  useRouteMatch,
} from "react-router-dom";
import BuatKuesionerPilihanGanda from "./features/BuatKuesionerPilihanGanda";
import BuatInstrumenPertanyaan from "./features/BuatInstrumenPertanyaan";
import BuatKuesionerFile from "./features/BuatKuesionerFile";
import BuatKuesionerLiklert from "./features/BuatKuesionerLiklert";

export default function Buat() {
  let { path } = useRouteMatch();

  let features = [
    { path: `${path}/buat-kuesioner-pilihan-ganda`, component: BuatKuesionerPilihanGanda },
    {
      path: `${path}/isi-kuesioner-pilihan-ganda`,
      component: BuatInstrumenPertanyaan,
    },
    { path: `${path}/buat-kuesioner-file`, component: BuatKuesionerFile },
    { path: `${path}/buat-kuesioner-liklert`, component: BuatKuesionerLiklert },
  ];
  return (
    <div
      className="w-full flex flex-col dark:text-white pt-16 px-10"
      style={{ minHeight: "100vh" }}
    >
      <div className="w-full">
        <button
          onClick={() => window.history.back()}
          className="flex flex-row items-center"
        >
          <ChevronLeftIcon className="h-4 w-4 mr-2" />
          <p>Kembali</p>
        </button>
      </div>

      <Router>
        <Switch>
          <Route path={path} exact>
            <div className="flex flex-col w-full">
              <BuatKuis />
              {/* <BuatPanduan />  */}
            </div>
          </Route>

          {features.map((val, idx) => {
            return (
              <Route key={idx} path={val.path}>
                <val.component />
              </Route>
            );
          })}
        </Switch>
      </Router>
    </div>
  );
}
